import MediaCarousel from './MediaCarousel';

customElements.define('media-carousel', MediaCarousel);
